/**
* Location based popup
*/
class locationPopup extends HTMLElement {
    constructor() {
        super();
        this.checkForInitial = false;
        if(document.referrer == 'https://shopify.com/'){
        // Utility.removeCookie('locationID')
        }

        if(Utility.getCookie('customer_location') != document.querySelector('[data-currentSelectedAddress]').getAttribute('data-currentSelectedAddress').toLowerCase()){
            Utility.removeCookie('locationID');
            Utility.removeCookie('cif_customerLocationData');
            Utility.removeFromLocalStorage('QuickListProducts');
            Utility.removeCookie('warehouseID');
        }

        // Instead of below JSOn we will use API
        //let locationJSONEle = document.querySelector('[data-locationScriptJSON]');
        this.locationPopup =  this.querySelector('.pdp-modal-content');
        this.closeLocationPopupbtn = this.querySelector('[data-close-location]')

        this.loadLocation();
        if(Utility.getCookie('locationID') == ''){
            this.checkForInitial = true;
        }else{
           
        }

        if(document.querySelector('[datalocation-select]')){
            document.querySelector('[datalocation-select]').addEventListener('change', this.selectChange.bind(this));
        }

      
    }

    getPreviousPageUrl() {
        history.back();
        return location.href;
    }

    loadLocation(){
        fetch('https://shopifyapi2.jinny.com/api/get-locations',{
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).
        then(response => {
            return response.json();
          }).then(response => {
            let locationJSON = (response);

            /* START:: Added restriction for not match URL or site with selected Location */
            if(Utility.getCookie('locationID') != ''){
                locationJSON.locations.forEach(function(data, index) {
                    if(parseInt(data.location_id) == parseInt(Utility.getCookie('locationID'))){
                        let dataurl = `https://${window.globalVariables.domain}${data.redirect_link}` 
                       
                    }
                });
            }

            this.fillPopup(locationJSON)
          }).catch((e) => {
              console.error(e);
              Rollbar.error(`File: component-location-popup.js, getting error on loadLocation: ${e}`);
          }).finally(() => {
              // Cart HTML fetch done
          });

        
    }

    fetchLocation(){
        fetch("https://jinny-beauty-backend.localhost/api/get-locations", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(requestData),
            }).then((data) =>{
                // console.log('data',data);
            });
    }

    openPopup(){
        document.getElementById('LocationPopup').querySelector('.modal').classList.add('open');
        document.querySelector('body').classList.add('open-location')
        siteOverlay.prototype.showOverlay();
    }
  
    /**
     * Escape Key Press to close drawer when focus is within the container
     *
     * @param {event} Event instance
     */
    fillPopup(jsonData) {
        
        let getCustomerTag = document.querySelector('[data-cust-tags]').getAttribute('data-cust-tags');
        let getCurrentSelectedLocation = document.querySelector('[data-currentSelectedAddress]').getAttribute('data-currentSelectedAddress').toLowerCase();

        if(getCurrentSelectedLocation != ''){

        let getCustomerTags = getCustomerTag.split(',');
        let cureentLocations = document.querySelector('[data-currentSelectedAddress]').getAttribute('data-currentlocations').split(',');

        let arrayLocation = [];
        getCustomerTags.forEach(function(data1, index1) {
            if(data1 != ''){
            let location = data1.replace('location_','');
            cureentLocations.forEach(data2 => {
                    if(parseInt(location) == parseInt(data2)){
                            arrayLocation.push(parseInt(data2));
                    }
                });
            }
        });
        var finalLocationArray = arrayLocation.filter((value, index, array) => array.indexOf(value) === index);
        jsonData.locations.forEach(function(data, index) {
            finalLocationArray.forEach(function(data1, index1) {
                if(data1 != ''){
                    
                    if(Number(data.warehouse_id) == Number(data1)){
                        
                        var optionEle = document.createElement("option");
                        optionEle.text = data.name;
                        optionEle.value = data.redirect_link;
                        // console.log('data.location_id',data.location_id);
                        optionEle.setAttribute('data-location-id',Number(data.location_id));
                        optionEle.setAttribute('data-warehouse-id',Number(data.warehouse_id));
                        optionEle.setAttribute('class','product-custom-option');
                        var select = document.querySelector("[datalocation-select]");
                        select.appendChild(optionEle);
                        Utility.setCookie('locationID', Number(data.location_id), 7);
                        Utility.setCookie('warehouseID', Number(data.warehouse_id), 7);
                        console.log('Utility.getCookie("locationID")',Utility.getCookie('locationID'));

                        if(Number(Utility.getCookie('locationID')) != Number(data.location_id)){
                            console.log('locationID changed', Number(data.location_id));
                            Utility.removeCookie('cif_customerLocationData');
                            Utility.setCookie('locationID', Number(data.location_id), 7);
                            Utility.setCookie('warehouseID', Number(data.warehouse_id), 7);
                            Utility.setCookie('customer_location',document.querySelector('[data-currentSelectedAddress]').getAttribute('data-currentSelectedAddress').toLowerCase());
                            Utility.setCookie('popupLocation', data.name, 7);
    
            
                            // fetch('/cart/clear.js', {
                            //     method: 'POST',
                            //     headers: {
                            //         'Content-Type': 'application/json',
                            //         'X-Requested-With': 'XMLHttpRequest'
                            //     }
                            //     })
                            //     .then(response => {
                            //     if (response.ok) {
                            //         console.log(response,'Cart cleared successfully.');
                            //         let cartElement = document.querySelector('cart-form'); 
                            //         cartElement.getCartData('updateCart');
                            //     } else {
                            //         console.error('Failed to clear the cart:', response.statusText);
                            //     }
                            //     })
                            //     .catch(error => {
                            //     console.error('Error clearing the cart:', error);
                            //     });
                        }

                    }
                }
            });
            if(parseInt(Utility.getCookie('locationID')) === parseInt(data.location_id)){
                if(document.querySelector('[data-location-id="' + data.location_id + '"]')){
                    document.querySelector('[data-location-id="' + data.location_id + '"]').selected = true;
                }
                var getSelect = document.querySelector("[datalocation-select]");
                var text = getSelect.options[getSelect.selectedIndex].text;
                document.querySelector('[data-location-name]').innerHTML = text;
                document.querySelector('[data-location-dropdown]').classList.remove('d-none');
            }
        });
        
        var selectOptions = document.querySelectorAll("[datalocation-select] option")
        if(selectOptions.length == 1){
            
            this.locationPopup.style = "margin-top:30px;"
            this.locationPopup.innerHTML = `<div class="text-center">There are no warehouse available at your shipping location. <br><br><a href="https://shopify.com/86571778347/account/locations">Please select a different shipping location </a></div>`;
            this.openPopup();
            this.closeLocationPopupbtn.classList.add('d-none');
            this.locationPopup.style = "margin-top:30px;"
        }
        }else{
            this.locationPopup.style = "margin-top:30px;"
            this.locationPopup.innerHTML = `<div class="text-center">There are no warehouse available at your shipping location. <br><br><a href="https://shopify.com/86571778347/account/locations">Please select a different shipping location </a></div>`;
            this.openPopup();
            this.closeLocationPopupbtn.classList.add('d-none');
            this.locationPopup.style = "margin-top:30px;"
        }
    }

    selectChange(event){

        let old_getLocation = Utility.getCookie('locationID');
        let old_getwarehouseId = Utility.getCookie('warehouseID');
        let old_customer_location =  Utility.getCookie('customer_location');
        let old_popupLocation =  Utility.getCookie('popupLocation');
        let old_websiteType = Utility.getCookie('websiteType');

        let selectedOption = event.currentTarget.options[event.currentTarget.selectedIndex].value;
        let getLocation = event.currentTarget.options[event.currentTarget.selectedIndex].getAttribute('data-location-id');
        let getwarehouseId = event.currentTarget.options[event.currentTarget.selectedIndex].getAttribute('data-warehouse-id');

        Utility.removeFromLocalStorage('QuickListProducts');
        Utility.removeCookie('cif_customerLocationData');
        Utility.setCookie('locationID', getLocation, 7);
        Utility.setCookie('warehouseID', getwarehouseId, 7);
        Utility.setCookie('customer_location',document.querySelector('[data-currentSelectedAddress]').getAttribute('data-currentSelectedAddress').toLowerCase());
        Utility.setCookie('popupLocation', event.currentTarget.options[event.currentTarget.selectedIndex].text, 7);

        // Clear currentLocation cookie to trigger cart update
        Utility.removeCookie('currentLocation');

        // Clear cart and redirect with longer delay to allow cart processing
        var xhttp = new XMLHttpRequest();
        xhttp.open("POST", "/cart/clear.js", true);
        xhttp.send();
        setTimeout(function(){
            window.location.href = selectedOption;
        },3000) // Increased from 1000ms to 3000ms

       
    }
  
}
customElements.define("location-popup", locationPopup);
